export const processError = (error) => {
    const response = error.response;
    if (response) {
        // errorHandler.js del backend devuelve { success: false, error: { message: '...' } }
        // Algunos endpoints legacy devuelven { message: '...' } directamente
        const message = response.data?.error?.message || response.data?.message || response.statusText || 'Error del servidor';
        return { status: response.status, message };
    }
    // Network errors (ERR_CONNECTION_RESET, timeout, etc.)
    if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
        return { status: 0, message: 'Sin conexión al servidor. Verifica tu internet.' };
    }
    return { status: 0, message: error.message || 'Error desconocido' };
}